import React, { useState, useEffect, useRef } from "react";
import { FaHome, FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_URL;
const SUPPORT_FORM_URL = process.env.REACT_APP_SUPPORT_FORM_URL || "";

const styles = {
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#636CCB",
    color: "#fff",
    padding: "0 40px",
    height: "60px",
    borderRadius: "0",
    margin: "0",
    boxShadow: "0 4px 8px rgba(0,0,0,0.25)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
  },

  logoGroup: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  logoImage: {
    height: "48px",
    width: "150px",
    borderRadius: "50%",
  },

  logoText: {
    fontSize: "1.6em",
    fontWeight: "600",
  },

  navRight: {
    display: "flex",
    alignItems: "center",
    gap: "30px",
  },

  navItem: {
    height: "35px",
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  homeIcon: {
    fontSize: "1.2em",
    color: "#ffffff",
    cursor: "pointer",
    transition: "0.3s",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  loginButton: {
    backgroundColor: "#fff",
    color: "#636CCB",
    border: "none",
    borderRadius: "20px",
    padding: "0 20px",
    height: "30px",
    width: "90px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "0.9em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  },

  themeToggle: {
    height: "30px",
    width: "90px",
    padding: "0 20px",
    borderRadius: "20px",
    backgroundColor: "#f6f5f2ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
    fontSize: "1.2em",
    border: "none",
  },

  footer: {
    width: "100%",
    backgroundColor: "#636CCB",
    color: "#fff",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1em",
    fontWeight: "600",
    position: "fixed",
    bottom: 0,
    left: 0,
    zIndex: 9999,
  },

  profileDropdown: {
    position: "absolute",
    top: "55px",
    right: "-50px",
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
    width: "260px",
    zIndex: 99999,
    overflow: "hidden",
    animation: "fadeIn 0.2s ease-out",
  },

  dropdownHeader: {
    padding: "15px 20px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "1rem",
    fontWeight: "600",
    color: "#333",
    borderBottom: "1px solid #eee",
  },

  dropdownItem: {
    padding: "12px 12px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "600",
    color: "#e63946",
    textAlign: "center",
    width: "100%",
    transition: "0.2s",
  },

  dropdownItemHover: {
    backgroundColor: "#f8f9fa",
  },

  messageIconBtn: {
    background: "rgba(255, 255, 255, 0.2)",
    border: "none",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "white",
    transition: "all 0.3s ease",
    position: "absolute",
    right: "30px",
  },

  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "transparent",
    zIndex: 1000,
  },

  popupContainer: {
    background: "white",
    borderRadius: "10px",
    padding: "18px 16px",
    width: "260px",
    position: "fixed",
    bottom: "75px",
    right: "25px",
    boxShadow: "0 2px 16px rgba(0, 0, 0, 0.15)",
    animation: "slideUpFromBottom 0.25s ease",
    pointerEvents: "auto",
    border: "1px solid #e5e5e5",
  },

  popupClose: {
    position: "absolute",
    top: "6px",
    right: "6px",
    background: "none",
    border: "none",
    fontSize: "20px",
    color: "#aaa",
    cursor: "pointer",
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    transition: "all 0.2s ease",
    lineHeight: 1,
  },

  popupContent: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
  },

  popupHeading: {
    color: "#2c3e50",
    margin: 0,
    fontSize: "17px",
    fontWeight: "700",
  },

  popupMessage: {
    color: "#666",
    fontSize: "13px",
    lineHeight: "1.5",
    margin: 0,
  },

  supportLink: {
    color: "#3498db",
    textDecoration: "none",
    fontWeight: "600",
    transition: "all 0.2s ease",
    cursor: "pointer",
  },

};

export default function Navbar({ onLoginClick }) {
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    return saved ? JSON.parse(saved) : false;
  });
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const dropdownRef = useRef(null);


  useEffect(() => {
    const checkLogin = () => {
      const username = localStorage.getItem("userName");
      const email = localStorage.getItem("userEmail");
      const google = localStorage.getItem("googleEmail");
      const admin = localStorage.getItem("adminEmail");

      setIsLoggedIn(!!(username || email || google || admin));
    };

    checkLogin();
    window.addEventListener("userLoggedIn", checkLogin);
    window.addEventListener("userLoggedOut", checkLogin);

    return () => { };
  }, []);

  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
    if (darkMode) {
      document.body.classList.add("dark-mode");
      document.documentElement.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
      document.documentElement.classList.remove("dark-mode");
    }

    // Dispatch event for other components
    window.dispatchEvent(new Event("themeChanged"));
  }, [darkMode]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const name =
    localStorage.getItem("adminEmail")
      ? "Admin"
      : localStorage.getItem("userName") ||
      localStorage.getItem("googleName") ||
      localStorage.getItem("userEmail");

  const logout = () => {
    localStorage.clear();
    window.dispatchEvent(new Event("userLoggedOut"));
    window.location.href = "/";
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Check if user is super admin
  const isSuperAdmin = localStorage.getItem("adminEmail") === "admin@navriti.com";
  const shouldShowSupportButton = isLoggedIn && !isSuperAdmin;

  return (
    <>
      <nav style={styles.nav}>
        <div style={styles.logoGroup}>
          <img src="/Source_Check.png" alt="Logo" style={styles.logoImage} />
        </div>

        <div style={styles.navRight}>
          <div style={styles.navItem}>
            <FaHome
              style={styles.homeIcon}
              title="Home"
              onClick={() => navigate("/")}
            />
          </div>

          {!isLoggedIn ? (
            <div style={styles.navItem}>
              <button style={styles.loginButton} onClick={onLoginClick}>
                Login
              </button>
            </div>
          ) : (
            <>
              <div style={{ position: "relative" }} ref={dropdownRef}>
                <div
                  style={styles.navItem}
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <FaUserCircle
                    style={{
                      fontSize: "1.8em",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                  />
                </div>
                {showDropdown && (
                  <div ref={dropdownRef} style={styles.profileDropdown}>

                    <div
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        textAlign: "center",
                        paddingTop: "12px",
                        color: "#333",
                      }}
                    >
                      {localStorage.getItem("adminEmail")
                        ? "Admin"
                        : localStorage.getItem("userName") ||
                        localStorage.getItem("googleName")}
                    </div>

                    <div
                      style={{
                        width: "85%",
                        height: "1px",
                        backgroundColor: "#e5e7eb",
                        margin: "10px auto",
                      }}
                    ></div>

                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: "#777",
                        textAlign: "center",
                        marginTop: "0px",
                        marginBottom: "16px",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        padding: "0 12px",
                        wordBreak: "break-all",
                      }}
                    >
                      {localStorage.getItem("adminEmail") ||
                        localStorage.getItem("userEmail") ||
                        localStorage.getItem("googleEmail")}
                    </div>

                    <button
                      onClick={logout}
                      style={{
                        width: "30%",
                        margin: "0 auto 18px auto",
                        display: "block",
                        backgroundColor: "#636CCB",
                        color: "white",
                        padding: "10px 0",
                        borderRadius: "10px",
                        border: "none",
                        fontSize: "1rem",
                        fontWeight: "400",
                        cursor: "pointer",
                      }}
                    >
                      Log out
                    </button>
                  </div>
                )}
              </div>
            </>
          )}

          <div style={styles.navItem}>
            <button
              onClick={() => setDarkMode(!darkMode)}
              style={styles.themeToggle}
            >
              {darkMode ? "🌙" : "☀️"}
            </button>
          </div>
        </div>
      </nav>

      <footer style={styles.footer}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "20px", position: "relative", width: "100%" }}>
          <p style={{ margin: 0 }}>Navriti Technologies © All rights reserved</p>

          {shouldShowSupportButton && (
            <button
              style={styles.messageIconBtn}
              onClick={() => setShowPopup(!showPopup)}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.3)";
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.transform = "scale(1)";
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.95)";
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              aria-label="Contact Support"
            >
              <img
                src="/feedback-svgrepo-com.svg"
                alt="Feedback"
                width="35"
                height="35"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </button>
          )}
        </div>

        {showPopup && (
          <div style={styles.popupOverlay} onClick={handleClosePopup}>
            <div
              style={styles.popupContainer}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                style={styles.popupClose}
                onClick={handleClosePopup}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#f5f5f5";
                  e.currentTarget.style.color = "#666";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "none";
                  e.currentTarget.style.color = "#aaa";
                }}
              >
                &times;
              </button>

              <div style={styles.popupContent}>
                <h2 style={styles.popupHeading}>Need help with SourceCheck?</h2>

                <p style={styles.popupMessage}>
                  If you are experiencing issues with SourceCheck, please submit your request below. Our Support Team will review and assist you at the earliest.{' '}
                  <a
                    href={SUPPORT_FORM_URL || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.supportLink}
                    onMouseOver={(e) => {
                      e.currentTarget.style.color = "#2980b9";
                      e.currentTarget.style.textDecoration = "underline";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.color = "#3498db";
                      e.currentTarget.style.textDecoration = "none";
                    }}
                    onClick={(e) => {
                      if (!SUPPORT_FORM_URL) {
                        e.preventDefault();
                        alert('Please configure REACT_APP_SUPPORT_FORM_URL in your .env file');
                      } else {
                        setShowPopup(false);
                      }
                    }}
                  >
                    Click here
                  </a>
                  {' '}
                </p>
              </div>

              {/* Tail border */}
              <div style={{
                content: '',
                position: 'absolute',
                bottom: '-9px',
                right: '18px',
                width: 0,
                height: 0,
                borderLeft: '9px solid transparent',
                borderRight: '9px solid transparent',
                borderTop: '9px solid #e5e5e5',
                zIndex: -1,
              }}></div>

              {/* Tail fill */}
              <div style={{
                content: '',
                position: 'absolute',
                bottom: '-8px',
                right: '19px',
                width: 0,
                height: 0,
                borderLeft: '8px solid transparent',
                borderRight: '8px solid transparent',
                borderTop: '8px solid white',
              }}></div>
            </div>
          </div>
        )}
      </footer>
    </>
  );
}
